import { memo } from 'react';
import {
  Box,
  Grid,
  ScrollablePanelContent,
} from '@uniqkey-frontend/shared-app';
import PartnerUserDetailsWidget from './components/PartnerUserDetailsWidget';
import PartnerUserResetWidget from './components/PartnerUserResetWidget';

interface IPartnerUserDetailsTabProps {
  partnerUserId: string;
}

const PartnerUserDetailsTab = (props: IPartnerUserDetailsTabProps) => {
  const { partnerUserId } = props;

  return (
    <ScrollablePanelContent p={3} pt={1}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <PartnerUserDetailsWidget partnerUserId={partnerUserId} />
          <Box mt={3} />
          <PartnerUserResetWidget partnerUserId={partnerUserId} />
        </Grid>
        <Grid item xs={6} />
      </Grid>
    </ScrollablePanelContent>
  );
};

export default memo(PartnerUserDetailsTab);
